import { render, staticRenderFns } from "./GrowthValue.vue?vue&type=template&id=6c38263c&scoped=true&"
import script from "./GrowthValue.vue?vue&type=script&lang=js&"
export * from "./GrowthValue.vue?vue&type=script&lang=js&"
import style0 from "./GrowthValue.vue?vue&type=style&index=0&id=6c38263c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c38263c",
  null
  
)

export default component.exports